import JumboDdMenu from "@jumbo/components/JumboDdMenu";
import VideoSettingsIcon from '@mui/icons-material/VideoSettings';
import { getObjectListByPropertyApi } from "api/general";
import { postMeetingVideoCallRecordApi, postMeetingVideoCallStartApi } from "api/meeting";
import { swal_error } from "app/utils/appHelpers";
import { MEETING_VIDEO } from "app/utils/constants/customConstant";
import { useState } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import VideoLinkDialog from "./Dialog/VideoLinkDialog";
import VideoWatchDialog from "./Dialog/VideoWatchDialog";
function VideoMenuGroup({ meeting, isEditable, afterUpdateFunc }) {

    const authUser = useSelector((state) => state.auth.authUser);
    const [videoLinkDialogStatus, setVideoLinkDialogStatus] = useState(false);
    const [videoWatchStatus, setVideoWatchDialogStatus] = useState(false);



    // JumboDdMenu menuItems[].type PropTypes string beklediği için sayı yerine string kullanıyoruz
    const menu = [
        ...(meeting.meetingUrl === null || meeting.meetingUrl === "" ? [
            { title: "Toplantı Bağlantısını Oluştur", type: '1' },
        ] : []),
        { title: "Toplantı Bağlantısını Ekle/Sil", type: '3' },
        { title: "Toplantı Video İzle", type: '4' }
    ];

    const filteredMenu = !isEditable
        ? menu.filter(item => item.type === '4')
        : menu;

    const videoButtonsClick = async (option) => {




        if (option.type === '1') {

            let meetingObj = { ...meeting };

            let title = "";
            let text = "";
            title = "Toplantı Bağlantısını Oluşturmak";
            text = "Toplantı bağlantısını oluşturmak";




            Swal.fire({
                title: title,
                text: text + " istediğinizden emin misiniz?",
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Evet',
                cancelButtonText: "Vazgeç"
            }).then(async (result) => {


                //    loading
                Swal.fire({
                    title: 'İşleminiz gerçekleştiriliyor...',
                    html: '<div><CircularProgress /></div>',
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    customClass: {
                        container: 'swal-container-custom'
                    },
                    didOpen: () => Swal.showLoading()
                });

                if (result.isConfirmed) {
                    meetingObj.adminUserId = authUser.id;
                    let { user, users, ...updatedMeetingObj } = meetingObj;

                    const res = await postMeetingVideoCallStartApi(updatedMeetingObj); // nbey ????

                    if (res.status) {
                        Swal.close();


                        meetingObj = {
                            ...updatedMeetingObj,
                            meetingUrl: res.data.joinUrl,
                            meetingShortUrl: res.data.meetingShortUrl,
                            teamsId: res.data.teamsId,
                            createVideoStatus: 1, // bunu sor video olusunca mı link olusunca mı vu 1 olacak ????
                            user: authUser,
                            users
                        };

                        // kontrol et teamsıd aldı mı?
                        afterUpdateFunc && afterUpdateFunc({ ...meetingObj });



                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: 'İşlem başarılı.',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }


                } else {
                    Swal.close();
                }





            })




        } else if (option.type === '2') {

            // loading
            Swal.fire({
                title: 'İşleminiz gerçekleştiriliyor...',
                html: '<div><CircularProgress /></div>',
                allowOutsideClick: false,
                showConfirmButton: false,
                customClass: {
                    container: 'swal-container-custom'
                },
                didOpen: () => Swal.showLoading()
            });

            let result = await getObjectListByPropertyApi(MEETING_VIDEO, "meetingId", meeting.id);
            let data = result.data;
            data = data.filter(item => item.status === 1 && item.type === 1);
            if (data.length > 0) {
                swal_error("Bu toplantının video kaydı zaten mevcuttur.", 5000)
                return;
            } else {

                const res = await postMeetingVideoCallRecordApi(meeting);
                Swal.close();
                if (res.status) {

                    // swal_success(res.data.message, 5000)

                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: res.data.message,
                        showConfirmButton: false,
                        timer: 5000
                    });


                } else {
                    swal_error(res.data.message, 5000)
                }
            }



        } else if (option.type === '3') {
            setVideoLinkDialogStatus(true);
        } else if (option.type === '4') {
            setVideoWatchDialogStatus(true);
        }

    }
    return (

        <>
            <JumboDdMenu icon={<VideoSettingsIcon sx={{ fontSize: 18, p: 0 }} />} menuItems={filteredMenu} onClickCallback={(option) =>
                videoButtonsClick(option)}
            />


            <VideoLinkDialog
                open={videoLinkDialogStatus}
                onClose={() => setVideoLinkDialogStatus(false)}
                meeting={meeting}
                setVideoLinkDialogStatus={setVideoLinkDialogStatus}

            />

            {
                videoWatchStatus && videoWatchStatus === true ?
                    <VideoWatchDialog
                        open={videoWatchStatus}
                        onClose={() => setVideoWatchDialogStatus(false)}
                        meeting={meeting}
                        setVideoWatchDialogStatus={setVideoWatchDialogStatus}

                    /> : ""
            }

        </>

    );
}

export default VideoMenuGroup